(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/betslipv2/assets/javascripts/flyingbetslip.js') >= 0) return;  svs.modules.push('/components/app/betslipv2/assets/javascripts/flyingbetslip.js');

'use strict';

svs.app.betslipv2.FlyingBetslip = Marionette.View.extend({
  template: function(data) {
    return svs.app.betslipv2.templates.flyingbetslip(data);
  },

  templateContext: function() {
    return {
      headerText: this.options && this.options.headerText || ''
    };
  },

  id: 'flyingbetslip',
  className: 'flyingbetslip',

  events: {
    'click .betslip-header': 'destroy'
  },

  regions: {
    betslipContent: '.betslip-content',
    betslipFooter: '.betslip-footer'
  },

  ui: {
    wrapper: '#flyingBetslipWrapper',
    header: '#flyingBetslipHeader'
  },

  swiper: undefined,

  initialize: function() {
    var self = this;
    var headerShown = $.Deferred();
    var contentShown = $.Deferred();
    var footerShown = $.Deferred();

    this.render();
    $('body').append(this.el);

    this.$el.on('touchmove', function(e) {
      var target = $(e.target);
      if (target.parents('#flyingBetslipWrapper').length === 0) {
        e.preventDefault();
      }
    });

    svs.core.detect.orientation.on('change', this.updateBrowserSize, this);

    this.getRegion('betslipContent').on(
      'show',
      function() {
        contentShown.resolve();
      },
      this
    );

    this.getRegion('betslipFooter').on(
      'show',
      function() {
        footerShown.resolve();
      },
      this
    );

    _.defer(function() {
      headerShown.resolve();
    });

    $.when(headerShown, contentShown, footerShown).then(function() {
      self.updateBrowserSize();
    });
  },

  updateBrowserSize: function() {
    var browserHeight = window.innerHeight || document.body.clientHeight;
    var contentHeight;
    var betslipHeight;
    var headerHeight = this.ui.header.get(0).clientHeight;
    var footerHeight = this.getRegion('betslipFooter').$el.get(0).clientHeight;
    var swiperOptions = {
      scrollbars: false,
      scrollingX: false,
      scrollingY: true
    };

    this.getRegion('betslipContent').$el.height('auto');

    contentHeight = this.getRegion('betslipContent').$el.get(0).clientHeight;
    betslipHeight = contentHeight + headerHeight + footerHeight;

    this.ui.wrapper.css({
      'margin-top': Math.max(
        0,
        Math.floor((browserHeight - betslipHeight) / 2)
      )
    });
    this.ui.wrapper.removeClass('invisible');

    if (betslipHeight > browserHeight) {
      contentHeight = browserHeight - (headerHeight + footerHeight);
    }

    this.getRegion('betslipContent').$el.css({
      height: contentHeight
    });

    if (!this.swiper) {
      this.swiper = svs.components.swiper.init(
        this.getRegion('betslipContent').$el.get(0),
        swiperOptions
      );
    }
    svs.components.swiper.disableBodyScroll();
  },

  onDestroy: function() {
    if (this.swiper) {
      svs.components.swiper.enableBodyScroll();
      this.swiper.destroy();
    }
    svs.core.detect.orientation.off('change', this.updateBrowserSize);
    this.$el.off('touchmove');
  }
});


 })(window);